import { ValidationFeedbackMessage } from 'components/shared/FormGroup/ErrorMessages';
import { TranslatedValidationError } from 'models/formError';
import { ReactNode } from 'react';

type ErrorWrapperProps = {
  children: ReactNode;
  error?: TranslatedValidationError;
};

export const ErrorWrapper = ({ children, error }: ErrorWrapperProps) => {
  return (
    <div className="h-100">
      {children}
      {error?.severity === 'Error' && <ValidationFeedbackMessage validationError={error} />}
    </div>
  );
};
